import type { LoadingLevelThresholds } from './loadingConstants';

/**
 * Tailwind classes for a loading figure on the five-step Ampel scale (green/yellow/orange/red
 * from the configurable cable or trafo levels). `onWhite` = Leaflet popup, which has no dark
 * theme; everywhere else the dark variants are included.
 */
export function loadingTextClass(pct: number, t: LoadingLevelThresholds, onWhite = false): string {
  if (pct >= t.red) return onWhite ? 'text-red-700' : 'text-red-700 dark:text-red-400';
  if (pct >= t.orange) return onWhite ? 'text-orange-700' : 'text-orange-700 dark:text-orange-400';
  if (pct >= t.yellow) return onWhite ? 'text-yellow-700' : 'text-yellow-700 dark:text-yellow-400';
  if (pct >= t.green) return onWhite ? 'text-green-700' : 'text-green-700 dark:text-green-400';
  return onWhite ? 'text-gray-700' : 'text-gray-700 dark:text-primary-300';
}

/** Fill colour of a loading bar on the same scale. */
export function loadingBarClass(pct: number, t: LoadingLevelThresholds): string {
  if (pct >= t.red) return 'bg-red-500';
  if (pct >= t.orange) return 'bg-orange-500';
  if (pct >= t.yellow) return 'bg-yellow-500';
  if (pct >= t.green) return 'bg-green-500';
  return 'bg-gray-400';
}
